var _path, _path2, _path3, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTruckBlueIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.41665 17.4167C9.42917 17.4167 10.25 16.5959 10.25 15.5833C10.25 14.5708 9.42917 13.75 8.41665 13.75C7.40412 13.75 6.58331 14.5708 6.58331 15.5833C6.58331 16.5959 7.40412 17.4167 8.41665 17.4167Z",
    fill: "#C3E2EC",
    stroke: "#008FC3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5833 17.4167C18.5959 17.4167 19.4167 16.5959 19.4167 15.5833C19.4167 14.5708 18.5959 13.75 17.5833 13.75C16.5708 13.75 15.75 14.5708 15.75 15.5833C15.75 16.5959 16.5708 17.4167 17.5833 17.4167Z",
    fill: "#C3E2EC",
    stroke: "#008FC3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.58333 15.5834H4.75V5.50004C4.75 5.25693 4.84658 5.02377 5.01849 4.85186C5.19039 4.67995 5.42355 4.58337 5.66667 4.58337H13.9167V15.5834M10.25 15.5834H15.75M19.4167 15.5834H21.25V10.0834M21.25 10.0834H13.9167M21.25 10.0834L18.5 5.50004H13.9167",
    stroke: "#008FC3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 1,
    transform: "matrix(1 0 0 -1 2 8)",
    fill: "#008FC3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 1,
    transform: "matrix(1 0 0 -1 7 11)",
    fill: "#008FC3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckBlueIcon);
export default __webpack_public_path__ + "static/media/TruckBlueIcon.e94a61c48a96a255ce2c7a6a16768aad.svg";
export { ForwardRef as ReactComponent };